module.exports = __webpack_public_path__ + "images/emoji/no_pedestrians.1fa90d61f63083282ee4.png";